import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from './ui/dialog';
import { ApplicationForm } from './ApplicationForm';
import { useApplicationModal } from '../context/ApplicationModalContext';

export const ApplicationModal = () => {
  const { open, prefillAmount, prefillTerm, closeModal } = useApplicationModal();

  return (
    <Dialog open={open} onOpenChange={(o) => (o ? null : closeModal())}>
      <DialogContent
        className="max-w-[560px] w-[calc(100vw-2rem)] p-0 gap-0 max-h-[92vh] overflow-y-auto rounded-2xl border-slate-200/70 shadow-[0_8px_24px_-6px_rgba(15,23,42,0.16),0_20px_60px_-12px_rgba(15,23,42,0.20)] [scrollbar-width:none] [-ms-overflow-style:none] [&::-webkit-scrollbar]:hidden"
        data-testid="application-modal"
      >
        <DialogHeader className="px-6 sm:px-7 pt-6 sm:pt-7 pb-0 text-left">
          <DialogTitle className="text-xl sm:text-2xl font-bold text-gray-900 leading-tight font-serif-display">
            İstehlak Krediti üçün ilkin müraciət
          </DialogTitle>
          <DialogDescription className="text-[13px] text-gray-500 leading-relaxed mt-2">
            Formanı doldurun, əməkdaşımız sizinlə əlaqə saxlasın. Yekun kredit qərarı və sənədləşmə ofisimizdə həyata keçirilir.
          </DialogDescription>
        </DialogHeader>
        <ApplicationForm
          variant="modal"
          prefillAmount={prefillAmount}
          prefillTerm={prefillTerm}
          onSuccess={closeModal}
        />
      </DialogContent>
    </Dialog>
  );
};
